import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }) {
      commit(mutations.LOADING);
      return api.mroi
        .getAll()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.LOADED);
          return err;
        });
    },
    getIO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.mroi
        .getIO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.LOADED);
          return err;
        });
    },
    amountCheck({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.mroi
        .amountCheck(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.LOADED);
          return err;
        });
    },
    evaluate({ commit }, dataROI) {
      commit(mutations.LOADING);
      return api.mroi
        .evaluate(dataROI)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.LOADED);
          return err;
        });
    }
  }
};
